import { connect, ConnectedProps } from 'react-redux';

import { RootState } from '../../../store/root-reducer';
import ScheduleReplyModal from './schedule-reply-modal';
import { ScheduleReplyModalProps } from './types';
import { getSequenceTimezoneRequest } from '../../../components/sequence/extra-actions';
import { GetSequenceTimezonePayload } from '../../../components/sequence/types';

const mapStateToProps = (state: RootState, ownProps: { emailId: number }) => {
  const {emailId} = ownProps;
  return {
    // Get Sequence Timezone Request
    getSequenceTimezoneRequestStatus:
      state.sequence.getSequenceTimezoneRequest[emailId]?.status,
    getSequenceTimezoneRequestMessage:
      state.sequence.getSequenceTimezoneRequest[emailId]?.message,
    getSequenceTimezoneRequestError:
      state.sequence.getSequenceTimezoneRequest[emailId]?.error,

    sequenceTimezone: state.sequence.getSequenceTimezoneResponse[emailId],
  };
};

const mapDispatchToProps = {
  sendGetSequenceTimezoneRequest: (payload: GetSequenceTimezonePayload) =>
    getSequenceTimezoneRequest(payload),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IProps = ConnectedProps<typeof connector> & ScheduleReplyModalProps;

export default connector(ScheduleReplyModal);
